import React from 'react';
const renderCard = ({ title, description, image }) => {
    return (React.createElement("div", { className: "bg-white p-6 flex md:flex-row flex-col md:items-center items-start md:gap-12 gap-8 rounded-2xl" },
        React.createElement("img", { src: image, alt: title, className: "w-39.5 h-39.5 shrink-0", onError: (e) => (e.currentTarget.style.visibility = 'hidden') }),
        React.createElement("div", { className: "w-full flex flex-col gap-2" },
            React.createElement("h3", { className: "text-gray-800 md:text-2xl md:leading-8 text-xl leading-6 font-semibold" }, title),
            React.createElement("p", { className: "text-gray-700 md:text-lg md:leading-7 text-base leading-6 font-normal" }, description))));
};
const DescriptionCard = ({ title, description, image, slug }) => {
    return slug ? (React.createElement("a", { href: slug }, renderCard({ title, description, image }))) : (renderCard({ title, description, image }));
};
export default DescriptionCard;
